export const environment = {
    production: false,
    // webtvUrl:"http://localhost:4200/",
    // apiUrl:"http://localhost:3500/api/",
    webtvUrl: "https://7live-webtv.lamptest.ipsnet.it/",
    apiUrl: "https://7live-webtv-api.lamptest.ipsnet.it/api/",
    recaptcha: '6LdBXTYqAAAAAAlhb9H3knLCpsZOuh23JRPZX0zc'
};